import { render, staticRenderFns } from "./HeaderNativeApp.vue?vue&type=template&id=65a7c163&scoped=true"
import script from "./HeaderNativeApp.vue?vue&type=script&lang=ts"
export * from "./HeaderNativeApp.vue?vue&type=script&lang=ts"
import style0 from "./HeaderNativeApp.vue?vue&type=style&index=0&id=65a7c163&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a7c163",
  null
  
)

export default component.exports